import { IonSpinner, IonText } from '@ionic/react';
import { ReactElement } from 'react';
import { CenteredContent } from '../ui/centered-content';

interface ContentLoadingProps {
  message?: string;
}

const ContentLoading = (props: ContentLoadingProps): ReactElement => {
  const { message } = props;

  return (
    <CenteredContent>
      <>
        <IonSpinner />
        {message && <IonText style={{ marginLeft: '10px' }}>{message}</IonText>}
      </>
    </CenteredContent>
  );
};

export { ContentLoading };
